import {postRequestWithoutSession} from "./helper-without-session"
export const getAllHome = (data) => postRequestWithoutSession('registration',data);
export const subUserSignApi = (data) => postRequestWithoutSession('update-linkedin',data);
export const getInTouchUser = (data) => postRequestWithoutSession('add-getInTouch',data);






// WEBPACK FOOTER //
// ./src/api/SignUp.js